import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetMachineExceptionsResData } from "./GetMachineExceptionsResData";

const ENDPOINT = "/log_analysis/exception";

export class GetMachineExceptionsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetMachineExceptionsReqData = null;

    constructor(params: GetMachineExceptionsReqData) {
        super();
        this.params = { ...params };
    }

    public async execute(): Promise<GetMachineExceptionsResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetMachineExceptionsResData(res);
    }
}

export class GetMachineExceptionsReqData {
    // FilterInstallations
    installationName: string = null;
    serialNumber: string = null;
    dateStart: Date = null;
    dateEnd: Date = null;

    constructor(installationName: string, serialNumber: string, dateStart: Date, dateEnd: Date) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
    }
}
